import { MapPin, Phone, Mail, Music2 } from "lucide-react";
import { Link } from "react-router-dom";
import Logo from "./Logo";

export default function Footer() {
  return (
    <footer data-testid="footer-section" className="bg-forest text-bone">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <div className="flex items-center gap-3">
              <Logo size={40} />
              <span className="font-display font-bold tracking-tight leading-none">
                ALL-SEASON
                <span className="block text-[10px] tracking-[0.3em] text-limed-bright font-sans font-semibold">
                  CREW
                </span>
              </span>
            </div>
            <p className="mt-4 font-display text-xl text-bone/90">Local Work. Fair Prices. Every Season.</p>
            <p className="mt-3 inline-flex items-center gap-2 text-sm text-bone/50">
              <MapPin size={14} />
              Located in Oak Grove & Grain Valley, Missouri
            </p>
          </div>

          <div>
            <p className="text-xs font-mono uppercase tracking-[0.25em] text-limed-bright mb-4">Get in touch</p>
            <div className="space-y-3">
              <a
                data-testid="footer-phone-link"
                href="tel:8164009576"
                className="flex items-center gap-3 text-sm text-bone/70 hover:text-limed-bright transition-colors duration-200"
              >
                <Phone size={15} /> 816-400-9576
              </a>
              <a
                data-testid="footer-email-link"
                href="mailto:ianmeek43@gmail.com"
                className="flex items-center gap-3 text-sm text-bone/70 hover:text-limed-bright transition-colors duration-200"
              >
                <Mail size={15} /> ianmeek43@gmail.com
              </a>
              <a
                data-testid="footer-tiktok-link"
                href="https://www.tiktok.com/@all_season_crew"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-sm text-bone/70 hover:text-limed-bright transition-colors duration-200"
              >
                <Music2 size={15} /> TikTok: @all_season_crew
              </a>
            </div>
          </div>

          <div>
            <p className="text-xs font-mono uppercase tracking-[0.25em] text-limed-bright mb-4">Services</p>
            <ul className="text-sm text-bone/60 space-y-2">
              <li>Trash Bin Cleaning — $15 per bin</li>
              <li>Pressure Washing — $75 minimum</li>
              <li>Leaf Cleanup — starting at $40</li>
              <li>Yard Cleanup — starting at $45</li>
              <li>Snow Removal — starting at $30</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/10 flex flex-wrap items-center justify-between gap-4">
          <p className="text-xs text-bone/40">
            © {new Date().getFullYear()} All-Season Crew · allseasoncrew.com
          </p>
          <Link
            data-testid="footer-admin-link"
            to="/admin"
            className="text-xs text-bone/40 hover:text-limed-bright transition-colors duration-200"
          >
            Crew Login
          </Link>
        </div>
      </div>
    </footer>
  );
}
